import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/command/command-group.component.js'

const tagName = 'dap-ds-command-group'

/**
 * `dap-ds-command-group`
 * @summary A command group is a group of command items.
 * @element dap-ds-command-group
 * @title - Command group
 * @group command
 *
 * @slot - The default slot for the command group.
 *
 * @cssprop --dds-command-group-gap - The gap between command group elements. Defaults to var(--dds-spacing-100)
 * @cssprop --dds-command-group-margin-bottom - The bottom margin of the command group. Defaults to var(--dds-spacing-200)
 * @cssprop --dds-command-group-border-radius - The border radius of the command group. Defaults to var(--dds-radius-small)
 * @cssprop --dds-command-group-label-font-weight - The font weight of the command group label. Defaults to var(--dds-font-weight-bold)
 * @cssprop --dds-command-group-items-gap - The gap between command items. Defaults to var(--dds-spacing-100)
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSCommandGroup',
})

export default reactWrapper
